package ai.wagemix.logic.pricing

import ai.wagemix.net.models.firebase.WMSubscriptionType
import co.touchlab.kermit.Severity
import com.fsryan.foundation.util.log.FSLog
import com.fsryan.foundation.util.log.sendEventInclusive

/*
 * The analytics events of the pricing presenter (planning/analytics-plan.md §5, "Billing"). Checkout itself is
 * reported by the API (§5a).
 */

private inline fun FSLog.sendWMPricingEvent(eventName: String, crossinline fields: MutableMap<String, Any>.() -> Unit) {
    sendEventInclusive(severity = Severity.Info, eventName = eventName) {
        fields()
    }
}

/** [plan] is the plan of the chosen price, `null` when the price list does not know the lookup key. */
internal fun FSLog.sendWMPlanSelected(plan: WMSubscriptionType?, currentPlan: WMSubscriptionType) {
    sendWMPricingEvent(eventName = "WMPlanSelected") {
        plan?.let { put("plan", it.stringValue) }
        put("current_plan", currentPlan.stringValue)
    }
}
